import { Store } from '@ngxs/store';
import { Component, OnInit } from '@angular/core';
import { InstituteItemComponent } from '../institute-item/institute-item.component';
import { CommonModule } from '@angular/common';
import { Institute } from '../../models/institute/randomInstituteResponse';
import { MyInstitutesSelectors } from '../../states/myInstitutes/my-institute-selector';
import { RemoveMyInstitute, UpdateMyInstitutesList } from '../../states/myInstitutes/my-institute-actions';
import { InstituteService } from '../../services/institute/institute.service';
import { InstituteSearchItemComponent } from "../institute-search-item/institute-search-item.component";
import { MyInstituteService } from '../../services/institute/myinstitute/my-institute.service';
import { UserSelectors } from '../../states/user/user-selector';
import { UserStateModel } from '../../states/user/user-state-model';

@Component({
  selector: 'app-my-institutes',
  standalone: true,
  imports: [InstituteItemComponent, CommonModule, InstituteSearchItemComponent],
  templateUrl: './my-institutes.component.html',
  styleUrl: './my-institutes.component.scss'
})
export class MyInstitutesComponent implements OnInit {
  myInstitutes: Institute[] = [];
  loadingInstituteId: string | null = null;
  user!: UserStateModel;
  randomInstitutes: Institute[] = [];

  constructor(
    private store: Store,
    private instituteService: InstituteService,
    private myInstituteService: MyInstituteService
  ) {
    this.getMyInstitutesFromState();
  }

  ngOnInit(): void {
    this.store.select(UserSelectors.getUser).subscribe({
      next: (response) => {
        this.user = response;
      },
      error: (error) => {
        console.warn('Error fetching user:', error);
      }
    });
  }

  private getUserId(): string {
    if (this.user?.id) return this.user.id;
    try {
      const accountData = localStorage.getItem('account');
      if (accountData) {
        const account = JSON.parse(accountData);
        return account.userId || account.id || '';
      }
    } catch { }
    return '';
  }

  getMyInstitutesFromState() {
    this.store.select(MyInstitutesSelectors.getMyInstitute).subscribe({
      next: (response) => {
        if (response) {
          this.myInstitutes = response.items;
          if (response.items.length === 0) {
            this.getRandomInstitutes();
          }
        }
      }
    });
  }

  toggleMyInstitute($event: string, isMyInstitute: boolean, index: number) {
    this.loadingInstituteId = $event;
    if (isMyInstitute) {
      this.store.dispatch(new RemoveMyInstitute({
        instituteId: $event,
        studentId: this.getUserId()
      })).subscribe({
        next: () => {
          this.randomInstitutes[index].isMyInstitute = false;
        },
        error: (error) => console.warn(error),
        complete: () => { this.loadingInstituteId = null; }
      });
    }
  }

  toggleMyRandomInstitute(
    $event: {
      instituteId: string,
      courseId: number | undefined,
      inTakeYear?: string,
      courseLevel?: number,
      mentorDeadline?: string | null
    },
    isMyInstitute: boolean,
    index: number
  ) {
    this.loadingInstituteId = $event.instituteId;

    if (isMyInstitute) {
      this.store.dispatch(new RemoveMyInstitute({
        instituteId: $event.instituteId,
        studentId: this.getUserId()
      })).subscribe({
        next: () => {
          const updatedInstitutes = [...this.randomInstitutes];
          updatedInstitutes[index].isMyInstitute = false;
          this.randomInstitutes = updatedInstitutes;
        },
        error: (error) => console.warn(error),
        complete: () => { this.loadingInstituteId = null; }
      });

    } else {
      const addModel: any = {
        studentId: this.getUserId(),
        isAddedByMentor: false,
        instituteId: $event.instituteId,
        courseId: $event.courseId || 0,
        inTakeYear: $event.inTakeYear ?? null,
        courseLevel: $event.courseLevel,
        mentorDeadline: $event.mentorDeadline
      };

      this.myInstituteService.addMyInstituteByRequestModel(addModel).subscribe({
        next: (postResponse: any) => {
          this.instituteService.getInstitute($event.instituteId).subscribe({
            next: (response) => {
              const enrichedInstitute: Institute = {
                ...response,
                myInstituteId: postResponse.id,
                courseId: postResponse.courseId || addModel.courseId,
                inTakeYear: postResponse.inTakeYear || addModel.inTakeYear,
                courseLevel: postResponse.courseLevel || addModel.courseLevel,
                isMyInstitute: true
              };
              this.store.dispatch(new UpdateMyInstitutesList(enrichedInstitute));
              const updatedInstitutes = [...this.randomInstitutes];
              updatedInstitutes[index] = enrichedInstitute;
              this.randomInstitutes = updatedInstitutes;
            }
          });
        },
        error: (error) => {
          console.warn(error);
          this.loadingInstituteId = null;
        },
        complete: () => { this.loadingInstituteId = null; }
      });
    }
  }

  getRandomInstitutes() {
    this.instituteService.getRandomInstitutes().subscribe({
      next: (response) => {
        if (response.result.length > 0) {
          this.store.select(MyInstitutesSelectors.getMyInstitute).subscribe({
            next: (results) => {
              this.randomInstitutes = response.result.map(institute => {
                const savedItem = results.items.find(item => item.id === institute.id);
                return {
                  ...institute,
                  isMyInstitute: !!savedItem,
                  myInstituteId: savedItem?.myInstituteId,
                  courseId: savedItem?.courseId,
                  inTakeYear: savedItem?.inTakeYear ?? null,
                  courseLevel: savedItem?.courseLevel != null
                    ? Number(savedItem.courseLevel) : null,
                };
              });
            },
            error: () => {
              this.randomInstitutes = response.result;
            }
          });
        }
      },
      error: (error) => {
        console.warn(error);
      }
    });
  }
}